import List from '../../../components/Main/Product/List'
import ProductModal from '../../../components/Main/Product/ProductModal'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function Product(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Product Management /</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Product Management'}
              subtitle={'Manage Product information and prices.'}
              color={'#FF6138'}
              iconType={'shopping-cart'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <ProductModal {...props} />
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Product.propTypes = {}
Product.defaultProps = {}

export default Product
